<template>
    <Layout
        :header="{ text: titleText, backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', step4,]" :index="2"></Process>
        </div>
        <div class="pb-4 flex justify-between items-center">
            <h2 class="font-bold text-2xl">確認以下已填寫資料</h2>
            <div class=" text-[#0093C1] textsm">
                <router-link :to="router.options.history.state.back">
                    <svg class="inline-block" fill="#0093C1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        viewBox="0 0 24 24">
                        <title>square-edit-outline</title>
                        <path
                            d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" />
                    </svg>修改
                </router-link>
            </div>
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">申請保單</h3>
            <CaseBox :caseBox="{ key: policyData.fullPolicyNo, value: `${policyData.item} ${policyData.itemName}`, }">
            </CaseBox>
        </div>

        <template v-for="(item, index) in Object.keys(result)" :key="index">
            <component :is="childComponents[item]" v-if="result[item]" :key="index" :result="result[item]" />
        </template>

        <div class="pb-4" v-if="clauseVisible">
            <h3 class="font-bold text-xl pb-4">取消豁免附約</h3>
            <CaseBox v-for="item in exemptRiderList">
                <p class="text-lg">{{ item.name }} ({{ item.item }})</p>
            </CaseBox>
        </div>
        <div class="pb-4">
            <h4 class="font-bold text-lg pb-3">是否以電子文件寄送本次變更批註內容</h4>
            <label class="flex">
                <div class="pt-1 pr-3">
                    <input class="w-[20px] h-[20px] " type="radio" id="isDigitalSendAgree" :value="true"
                        v-model="isDigitalSendAgree">
                </div>
                <p class="flex-1">
                    本次變更批註內容將以電子文件寄送至本次填寫或本人留存於貴公司之電子郵件信箱；未提供電子郵件信箱或郵件遭退回，則發送簡訊通知；若未留存行動電話或簡訊通知亦遭退回，則改以紙本寄送。若您未申請電子保單且不同意以電子文件寄送請勾選『變更批註以紙本寄送』。
                </p>
            </label>
            <label class="flex pt-1">
                <div class="pt-1 pr-3">
                    <input class="w-[20px] h-[20px]" type="radio" id="isDigitalSendAgree" :value="false"
                        v-model="isDigitalSendAgree">
                </div>
                <p class="flex-1">
                    變更批註以紙本寄送
                </p>
            </label>
        </div>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>

<script setup>
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'

import { ref, computed, provide } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import routeName from '@/router/constant.js';
import { confirmTransaction, getResult } from '@/apis/system';
import { postAgreeEndorse, postNotAgreeEndorse } from '@/apis/endorse.js';
import Loading from '@/components/Loading.vue';
import childComponents from './childComponents';
import aplCatlCode from '@/json/aplCatlCode';

const store = useStore();
const router = useRouter();
const isLoading = ref(false);
const isDigitalSendAgree = ref(true);
const aplCatl = computed(() => store.state.services.aplCatl);
const policyData = computed(() => store.state.policy.policy);
const hasData = ref(false);
const result = ref({});
const step4 = ref('視訊預約');
//取消豁免條款顯示
const clauseVisible = ref(false);
const infoBoxVisble = ref(false);

const exemptRiderList = ref([])
const titleText = ref('');

const getResultData = () => {
    isLoading.value = true
    getResult().then(res => {
        result.value = res.data;
        result.value.needEndorse = res.data.needEndorse;
        result.value.needEndorseDesc = res.data.needEndorseDesc;
        if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
            result.value.notMeeting = res.data.beneficiaryChange.notMeeting;
            if (result.value.notMeeting) {
                step4.value = '手機驗證'
            }
        } else {
            result.value.notMeeting = false;
        }
        hasData.value = res.success;
        exemptRiderList.value = res.data?.applicantChange?.exemptRiderList || [];
        clauseVisible.value = exemptRiderList.value.length > 0
        infoBoxVisble.value = exemptRiderList.value.length > 0
    }).finally(() => {
        isLoading.value = false
    });
};
getResultData();

provide('aplCatl', aplCatl);
if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
    titleText.value = '受益人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
    titleText.value = '要保人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
    titleText.value = '要保人或被保險人姓名變更'
}
// 按下確認按鈕
// const mobileVerify = () => {
//     // checkEndorseData();
//     // if (isDisabledButton.value) return;
//     // if (aplCatl.value === aplCatlCode.POLICY || aplCatl.value === aplCatlCode.CONTACT) {
//     //     /* 開始門號核實 */
//     //     getNeedMIDVerify().then(res => {
//     //         if (res.data.flag) {
//     //             postApiMid.value = true;
//     //         } else {
//     //             goNextPage();
//     //         }
//     //     });
//     // } else {
//     //     goNextPage();
//     // };
//     goNextPage();
//     console.log('submit!!');
// };

const checkEndorseData = () => {
    return postAgreeEndorse().then(res => res.data).catch(() => null);
};

// 送出確認資料
const checkData = () => {
    // 雲端E櫃檯沒有該欄位，故固定傳'N'
    return confirmTransaction('N').then(res => res.data).catch(() => null);
};

const goNextPage = async () => {

    isLoading.value = true;
    if (isDigitalSendAgree.value) {
        await checkEndorseData();
    } else {
        await postNotAgreeEndorse();
    }
    const response = await checkData();
    if (response) {
        if (!result.value.notMeeting) {
            router.push({ name: routeName.CLOUD_E_COUNTER_PHONE });
        } else {
            router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_CONTACT_INFO_CHECK });
        }

    } else {
        isLoading.value = false;
    }
};
</script>
